export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#f7f7f4] py-12 px-4">
      <div className="mx-auto max-w-3xl">
        <div className="mb-8">
          <a href="/" className="text-sm text-neutral-500 hover:text-neutral-800">
            ← Back to AusProp
          </a>
        </div>

        <div className="rounded-2xl border border-neutral-200 bg-white p-8 md:p-12 space-y-8">
          <div>
            <h1 className="text-2xl font-bold text-neutral-900">Terms of Service</h1>
            <p className="mt-2 text-sm text-neutral-500">Last updated: April 2026</p>
          </div>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">1. About AusProp</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              AusProp is a property investment tracking and analysis tool operated by AusProp
              (ABN 37 317 085 485). The service is accessible at ausprop.app.
            </p>
            <p className="text-sm text-neutral-600 leading-relaxed">
              AusProp provides information and calculations to assist property investors in tracking
              their portfolios. It is not a financial planning service and does not provide personal
              financial advice. Nothing in AusProp constitutes advice within the meaning of the
              Corporations Act 2001 (Cth) or the National Consumer Credit Protection Act 2009 (Cth).
              You should consult a licensed financial adviser before making investment decisions.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">2. Your account</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              You are responsible for maintaining the security of your account credentials. Do not share
              your password with anyone. You are responsible for all activity that occurs under your account.
              If you suspect unauthorised access, contact us immediately at propertyoshq@gmail.com.
            </p>
            <p className="text-sm text-neutral-600 leading-relaxed">
              You must provide accurate information when using AusProp. The accuracy of all calculations
              and analysis depends entirely on the data you enter. AusProp does not verify the accuracy
              of data you provide.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">3. Subscription and billing</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              The Investor plan is billed at $39.00 AUD per month. Subscriptions renew automatically at
              the end of each billing period unless cancelled. You may cancel at any time via the
              Billing page inside the app. Cancellation takes effect at the end of your current billing
              period — you retain access until then.
            </p>
            <p className="text-sm text-neutral-600 leading-relaxed">
              Payments are processed by Stripe. We do not store your card details. Refunds are not
              provided for partial billing periods unless required by Australian Consumer Law.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">4. Data and privacy</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              Your data is stored securely. See our{" "}
              <a href="/privacy" className="underline text-neutral-900 hover:text-neutral-600">
                Privacy Policy
              </a>{" "}
              for full details of what we collect, how we store it, and your rights.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">5. Calculations and liability</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              All calculations in AusProp — including tax estimates, CGT calculations, cashflow
              projections, and borrowing capacity estimates — are indicative only. They are based on
              the data you provide and publicly available tax rates. They do not constitute professional
              tax or financial advice and may not reflect your individual circumstances.
            </p>
            <p className="text-sm text-neutral-600 leading-relaxed">
              To the maximum extent permitted by Australian law, AusProp accepts no liability for
              any loss or damage arising from reliance on information or calculations provided by this
              service. You use AusProp at your own risk.
            </p>
            <p className="text-sm text-neutral-600 leading-relaxed">
              Nothing in these Terms limits any rights you may have under the Australian Consumer Law.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">6. Acceptable use</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              You may not use AusProp for any unlawful purpose, to transmit harmful content, or to
              attempt to gain unauthorised access to any system. We reserve the right to suspend or
              terminate accounts that breach these terms.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">7. Changes to these terms</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              We may update these Terms from time to time. We will notify you of material changes via
              email or a notice in the app. Continued use of AusProp after changes constitutes
              acceptance of the updated Terms.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">8. Governing law</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              These Terms are governed by the laws of Victoria, Australia. Any disputes will be subject
              to the exclusive jurisdiction of the courts of Victoria.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-neutral-800">9. Contact</h2>
            <p className="text-sm text-neutral-600 leading-relaxed">
              For questions about these Terms, contact us at:{" "}
              <a href="mailto:propertyoshq@gmail.com" className="underline text-neutral-900 hover:text-neutral-600">
                propertyoshq@gmail.com
              </a>
            </p>
            <p className="text-sm text-neutral-600">ABN: 37 317 085 485</p>
          </section>
        </div>
      </div>
    </div>
  );
}
